import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.faq.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-faq-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.faq.list/view.scss */
/* src/app/portal.gsdcadmin.faq.list/view.scss: no such file or directory */`],
})
export class PortalGsdcadminFaqListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() ticketing_id: any;
    public faqs: any = [];
    public loaded: boolean = false;

    public searchTerm = "";
    public pagination: any = {
        page: 1,
        end: 1,
        start: 1,
    };
    public total = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', "/landing");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { text: this.searchTerm, page: this.pagination.page });
        if (code != 200) return await this.service.alert.error("Error!");
        this.faqs = data.rows;
        for (let item of this.faqs) {
            item.tag = JSON.parse(item.tag.replace(/'/g, '"'));
        }
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }
}

export default PortalGsdcadminFaqListComponent;